@if (mode() === 'view') {
  <mat-chip class="ms-0 filter-card-chip" [removable]="true" (removed)="remove.emit()" (click)="chipClick()">
    @if (field().type === 'dateRange') {
      <div class="d-flex align-items-center date-chip-content">
        <button
          type="button"
          class="date-chip-icon-button"
          [matTooltip]="'button.previous' | translate"
          [attr.aria-label]="'button.previous' | translate"
          (click)="$event.stopPropagation(); shiftDateRange(-1)"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="date-chip-label">{{ label() }}</span>
        <button
          type="button"
          class="date-chip-icon-button date-chip-remove-button"
          [attr.aria-label]="'button.remove' | translate"
          (click)="$event.stopPropagation(); remove.emit()"
        >
          <mat-icon>cancel</mat-icon>
        </button>
        <button
          type="button"
          class="date-chip-icon-button"
          [matTooltip]="'button.next' | translate"
          [attr.aria-label]="'button.next' | translate"
          (click)="$event.stopPropagation(); shiftDateRange(1)"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    } @else {
      <span>{{ label() }}</span>
    }
    <mat-icon matChipRemove>cancel</mat-icon>
  </mat-chip>
} @else {
  <app-filter-card-field-input
    [field]="field()"
    [initialValue]="value()"
    (commit)="commitEdit($event)"
    (pendingChange)="edit.emit($event)"
    (dismissed)="mode.set('view')"
  ></app-filter-card-field-input>
}
